import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { QuoteWithRegulation } from 'state/quotes/results/result.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface FetchLastQuoteApi {
  getLastQuote(quoteId: string): Observable<QuoteWithRegulation>;
}

export const lastQuoteApi = (http: IHttpClient): FetchLastQuoteApi => ({
  getLastQuote(quoteId) {
    return http
      .getJSON<QuoteWithRegulation>({
        url: `api/v1/quote/${quoteId}/last/price`,
      })
      .pipe(map(r => r.payload));
  },
});
